import { gql } from '@apollo/client'

export const GET_CURRENT_USER = gql`
  query {
    currentUser {
      id
      profile
      firstName
      lastName
      gender
      birthDate
      birthCity
      citizenship
      idType
      idDocumentNumber
      passportIssuingAgency
      idDocumentCountry
      address
      addressCity
      addressZipcode
      addressCountry
      email
      cellphone
      highestEducation
      experience
      employment
      prevEmployment
      highestEducation
      occupationGroup
      idNowTransactionId
      idNowId
      idNowStatus
      whitelisted
      politicallyExposed
      taxNumber
      notUSTax
      default_payment
      payment_accounts {
        id
        IBAN
        name
        bank
        BIC
      }
      transactions {
        id
        user_id
        token_id
        type
        status
        hash
        to
        investment_id
        type
      }
      investments {
        id
        user_id
        sale_id
        payment_id
        token_id
        status
        amount
        paid
        currency
        revocable
      }
      transactionsPerYear
      volumePerYear
      availableCash
      monthlySalary
    }
  }
`

export const GET_SALES = gql`
  query {
    findTokens(company: "FinPro") {
      id
      sales {
        id
      }
    }
  }
`

export const FIND_INVESTMENTS = gql`
  query findInvestments($status: String, $user_id: ID) {
    findInvestments(status: $status, user_id: $user_id) {
      id
      user_id
      sale_id
      # payment_id
      amount
      paid
      status
      currency
      user {
        email
        firstName
        lastName
        whitelisted
        address
        addressCity
        addressZipcode
        addressCountry
        email
        cellphone
      }
      revocable
      token_id
      token {
        id
        name
        symbol
        company
        description
        contract
        value
        currency
      }
      user {
        email
        firstName
        lastName
        whitelisted
        address
        addressCity
        addressZipcode
        addressCountry
        email
        cellphone
      }
      transactions {
        type
        hash
        status
        to
      }
    }
  }
`

export const GET_REVOCABLE = gql`
  query {
    getRevocable {
      id
      user_id
      sale_id
      # payment_id
    }
  }
`

export const GET_CURRENT_TRANSACTION = gql`
  query getTransaction($transaction_id: Float!) {
    getTransaction(transaction_id: $transaction_id) {
      status
      hash
      id
      user_id
    }
  }
`

export const GET_OFFERINGS = gql`
  query {
    getCurrentSales {
      id
      total_sold
      token_id
      token {
        id
        name
        symbol
        company
        description
        contract
        value
        currency
        cost
        asset_type
        location
        LTV
        interest
      }
      min
      max
      start
      end
      cap
      price
      currency
      documents {
        filename
        hash
        uri
      }
    }
  }
`

export const CHECK_WHITELIST = gql`
  query {
    checkWhitelisted
  }
`

export const GET_IDNOW_INFO_FOR_USER = gql`
  query getIdNowIdentForUser($idNowTransactionId: String!) {
    getIdNowIdentForUser(idNowTransactionId: $idNowTransactionId) {
      birthday {
        ...userDataRecord
      }
      birthname {
        ...userDataRecord
      }
      birthplace {
        ...userDataRecord
      }
      firstname {
        ...userDataRecord
      }
      lastname {
        ...userDataRecord
      }
      city {
        ...userDataRecord
      }
      country {
        ...userDataRecord
      }
      zipcode {
        ...userDataRecord
      }
      street {
        ...userDataRecord
      }
      nationality {
        ...userDataRecord
      }
      gender {
        ...userDataRecord
      }
    }
  }

  fragment userDataRecord on UserDataRecord {
    status
    value
    original
  }
`

export const GET_ALL_USERS = gql`
  query findUsers(
    $email: String
    $whitelisted: Boolean
    $account: String
    $firstName: String
    $lastName: String
  ) {
    findUsers(
      email: $email
      whitelisted: $whitelisted
      account: $account
      firstName: $firstName
      lastName: $lastName
    ) {
      id
      email
      firstName
      lastName
      whitelisted
      addressCountry
      birthDate
      prevEmployment
      employment
      highestEducation
      occupationGroup
      address
      addressCity
      addressZipcode
      cellphone
      idDocumentCountry
      idType
      idDocumentNumber
      idNowStatus
      idNowTransactionId
      birthCity
      citizenship
      gender
    }
  }
`
